"use client"
import ShowPageWrapper from '@/components/ShowPageWrapper';

/**
 * Not Found page
 * This is rendered for any unmatched routes in Next.js
 * We use ShowPageWrapper which extracts the slug and renders HomePageClient
 * The backend will handle returning proper 404s for invalid shows
 */
export default function NotFound() {
  return <ShowPageWrapper />;
}
